import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const Settings2Icon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17 13C18.3059 13 19.4141 13.8353 19.8262 15H22V17H19.8262C19.4141 18.1647 18.3059 19 17 19C15.6941 19 14.5859 18.1647 14.1738 17H2V15H14.1738C14.5859 13.8353 15.6941 13 17 13ZM17 15C16.4477 15 16 15.4477 16 16C16 16.5523 16.4477 17 17 17C17.5523 17 18 16.5523 18 16C18 15.4477 17.5523 15 17 15Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8 6C9.30585 6 10.4141 6.83532 10.8262 8H22V10H10.8262C10.4141 11.1647 9.30585 12 8 12C6.69415 12 5.58594 11.1647 5.17383 10H2V8H5.17383C5.58594 6.83532 6.69415 6 8 6ZM8 8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10C8.55228 10 9 9.55228 9 9C9 8.44772 8.55228 8 8 8Z'
                fill='currentColor'
            />
        </>
    ),
})

Settings2Icon.displayName = 'Settings2Icon'
